import qs from 'qs';
import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = ({ tagId }: QueryParams) => {
    const querystring = qs.stringify({ tagId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteTag${querystring}`;

    return network.post(url).then((response) => response.data);
};

export const useMutationDeleteTag = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    tagId: number;
}
